<div class="wrap-header">
    <header>
        <div class="container">
            <nav class="navbar">
                <a class="navbar-brand" href="/">
                    <img alt="DeltaWizard.ai" height="24" src="assets/images/logo.svg">
                </a>

                <main-menu></main-menu>
            </nav>
        </div>
    </header>
</div>

<main>
    <div class="container">
        <div *ngIf="noProjectsAtAll()" class="block-create-first mb-16">
            <div class="mb-24">
                <img src="assets/images/icon-empty.svg" alt="No results" />
            </div>
            <h3 class="mb-24">
                Create your first project
            </h3>
            <button (click)="showNewProjectDialog()" class="btn">Create New</button>
        </div>
        <ng-container *ngIf="!noProjectsAtAll()">
            <div class="d-flex justify-content-between align-items-center mb-24">
                <h3>
                    My projects
                </h3>
                <a *ngIf="projects.length > 0 || (dataLoaded && projects.length == 0 && isFilteringApplied())" (click)="showNewProjectDialog()" class="btn">Create New</a>
            </div>
            <div>
                <div class="table-container column-border table-project-list">
                    <!-- Header row -->
                    <div class="row header">
                        <div class="cell">
                            <span class="subtitle-2">Name</span>
                            <span [matMenuTriggerFor]="searchMenu" [ngClass]="isNameFilteringApplied() ? 'material-icons' : 'material-icons-outlined'">search</span>

                            <mat-menu #searchMenu="matMenu">
                                <div class="mat-menu-search" (click)="$event.stopPropagation();">
                                    <input class="input-no-borders" type="text" [(ngModel)]="projectNameFilter" (input)="onNameFilterChange()" placeholder="Search by name...">
                                </div>
                            </mat-menu>
                        </div>
                        <div class="cell">
                            <span class="subtitle-2">Tags</span>
                            <span *ngIf="allTags?.length" [matMenuTriggerFor]="filterMenu" [ngClass]="isTagFilteringApplied() ? 'material-icons' : 'material-icons-outlined'">filter_list</span>

                            <mat-menu #filterMenu="matMenu">
                                <div *ngFor="let tag of allTags" mat-menu-item (click)="$event.stopPropagation();">
                                    <label class="custom-checkbox custom-checkbox-small is-check">
                                        <input type="checkbox" id="checkbox-{{tag.name}}" [checked]="isTagSelected(tag.name)" (change)="toggleTagFilter(tag.name)" />
                                        <span></span>
                                    </label>
                                    <label for="checkbox-{{tag.name}}">{{tag.name}}</label>
                                </div>
                            </mat-menu>
                        </div>
                        <div class="cell">
                            <span class="subtitle-2">Created</span>
                        </div>
                        <div class="cell">
                            <span class="subtitle-2">Updated</span>
                        </div>
                    </div>

                    <!-- Data rows -->
                    <div *ngFor="let proj of projects" class="row">
                        <div class="cell">
                            <a (click)="gotoProject(proj)">
                                {{proj.name}}
                            </a>
                        </div>
                        <div class="cell">
                            <div *ngFor="let tag of proj.tags" class="tag">{{tag}}</div>
                            <div *ngIf="proj.currentStep!=ImportStep.Cards" class="tag tag-gray">Import</div>
                        </div>
                        <div class="cell">
                            {{proj.creationDate}}
                        </div>
                        <div class="cell">
                            {{proj.lastModificationDate}}
                        </div>
                        <div class="cell cell-hover">
                            <button (click)="showEditProjectDialog(proj.id)" class="btn btn-icon btn-transparent"><span class="material-icons-outlined">info</span></button>
                            <a (click)="duplicateProject(proj)" [class.disabled]="proj.currentStep!=ImportStep.Cards" [style.pointer-events]="proj.currentStep!=ImportStep.Cards ? 'none' : 'auto'" class="btn btn-icon btn-transparent"><span class="material-icons-outlined">content_copy</span></a>
                            <a target="_blank" [href]="proj.downloadDwpUrl" [class.disabled]="proj.currentStep!=ImportStep.Cards" [style.pointer-events]="proj.currentStep!=ImportStep.Cards ? 'none' : 'auto'" class="btn btn-icon btn-transparent"><img src="assets/images/icon-dwp.svg" alt="File DWP"></a>
                            <a target="_blank" [href]="proj.downloadXlsxUrl" class="btn btn-icon btn-transparent"><img src="assets/images/icon-xls.svg" alt="File XLS"></a>
                            <a mwlConfirmationPopover popoverTitle="Confirm delete" popoverMessage="Are you sure?" cancelText="No" confirmText="Yes" placement="left"
                                                    (confirm)="deleteProject(proj)"><span class="material-icons-outlined">delete</span></a>
                        </div>
                    </div>
                    
                    <div *ngIf="!dataLoaded && projects.length == 0" class="row loading">
                        <div class="cell"></div>
                        <div class="cell"></div>
                        <div class="cell"></div>
                        <div class="cell"></div>
                        <div class="cell"></div>
                    </div>
                    
                    <div *ngIf="dataLoaded && projects.length == 0 && isFilteringApplied()" class="block-no-results">
                        <div>
                            <img src="assets/images/icon-empty.svg" alt="No results" />
                        </div>
                        <h3>
                            No Results
                        </h3>
                        <span class="subitile-2">Change filter settings</span>
                    </div>
                </div>
                <div *ngIf="projects?.length" class="d-flex justify-content-center mt-24">
                    <button (click)="loadMoreProjects()" [ngClass]="{'loading-small': loading}" class="btn btn-text">Show more</button>
                </div>
            </div>
        </ng-container>
    </div>
    <articles-view>
    </articles-view>
    <footer class="mt-0">
        <span class="body-2">© DeltaWizard. All rights reserved</span>
    </footer>
</main>
